module.exports = {
	"items": [
		{
			"title": "Dashboard",
			"icon": "fa fa-lg fa-fw fa-home",
			"items": [
				{
					"route": "/app",
					"title": "Analytics Dashboard"
				}
			]
		},
		{
			"title": "通知管理",
			"icon": "fa fa-lg fa-fw  fa-comment",
			"items": [
				{
					"route": "/notification/notification_push",
					"title": "Push 通知"
				},
				{
					"route": "/notification/notification_list",
					"title": "Push 通知管理"
				}
			]
		},
		{
			"title": "集計データ",
			"icon": "fa fa-lg fa-fw fa-table",
			"items": [
				{
					"route": "/datacollect/user_card_breakdown",
					"title": "登録カード内訳"
				},
				{
					"route": "/datacollect/user_card_count",
					"title": "登録枚数と分布図"
				},
				{
					"route": "/datacollect/booking_count",
					"title": "予約"
				}
			]
		},
		{
			"title": "DB関連",
			"icon": "fa fa-lg fa-fw fa-table",
			"items": [
				{
					"route": "/db_report/shop_search_hitrate",
					"title": "店舗データ"
				},
				{
					"route": "/db_report/item_register",
					"title": "カード登録"
				},
				{
					"route": "/db_report/item_register_unique",
					"title": "カードユニーク登録"
				},
				{
					"route": "/db_report/item_register_epark",
					"title": "Epark店舗"
				},
				{
					"route": "/db_report/item_register_unique_epark",
					"title": "Eparkユニーク店舗"
				}
			]
		},
		{
			"title": "マネタイズ・貢献利益",
			"icon": "fa fa-lg fa-fw fa-table",
			"items": [
				{
					"route": "/monetize/booking",
					"title": "Web予約・PPC予約"
				}
			]
		},
		{
			"title": "会員化",
			"icon": "fa fa-lg fa-fw fa-table",
			"items": [
				{
					"route": "/member/epark_login_user",
					"title": "Eparkログイン数"
				}
			]
		},
		{
			"title": "ユーザーの声",
			"icon": "fa fa-lg fa-fw fa-table",
			"items": [
				{
					"route": "/uservoice/request",
					"title": "リクエスト数"
				},
				{
					"route": "/uservoice/contact",
					"title": "ご意見集計"
				},
				{
					"route": "/uservoice/contact_manage",
					"title": "ご意見版管理"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./config/menu-items.json
// module id = 1023
// module chunks = 0